import classnames from 'classnames/bind'
import { BigNumber } from 'bignumber.js'
import { isUndefined } from 'lodash-es'
import { useTranslation } from 'next-i18next'

// Methods
import { useDiscountRate } from '@/hooks/useDiscountRate'

// Constants
import { PROMOTION_DISCOUNT_RATE } from '@/constants/promotion'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface IDiscountRateTag {
  productPrice: number
  productOriginalPrice: number
  gapPosition?: 'top' | 'right' | 'bottom' | 'left' | 'none'
}

export const defaultProps = {
  gapPosition: 'none',
}

const DiscountRateTag = (props: IDiscountRateTag) => {
  const { productPrice, productOriginalPrice, gapPosition } = props

  const { t } = useTranslation()
  const discountRate = useDiscountRate(productPrice, productOriginalPrice)

  return (
    <>
      {!isUndefined(productPrice) &&
        !isUndefined(productOriginalPrice) &&
        BigNumber(discountRate).lt(PROMOTION_DISCOUNT_RATE.MAX) &&
        BigNumber(discountRate).gt(PROMOTION_DISCOUNT_RATE.MIN) && (
          <div
            className={cx('discountRateTag', {
              'discountRateTag--topMargin': gapPosition === 'top',
              'discountRateTag--rightMargin': gapPosition === 'right',
              'discountRateTag--bottomMargin': gapPosition === 'bottom',
              'discountRateTag--leftMargin': gapPosition === 'left',
            })}
          >
            {t('Common_Discount_Rate', { discountRate: discountRate })}
          </div>
        )}
    </>
  )
}

DiscountRateTag.defaultProps = defaultProps
export default DiscountRateTag
